export default __webpack_public_path__ + "static/media/logo.9c223e84.png";